import Theme from '@adsk/alloy-react-theme';

export const containerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
};

export const productsLabelStyle = {
  color: Theme.colors.charcoal900,
  ...Theme.typography.bodyLargeBold,
};

export const inviteToProductsLabelStyle = {
  color: Theme.colors.charcoal900,
  ...Theme.typography.heading3,
  marginBottom: '5px',
};

export const cantAddMembersTextStyle = {
  ...Theme.typography.heading2,
  marginBottom: '8px',
};
